import { render, staticRenderFns } from "./UserTypeSelectorContainer.vue?vue&type=template&id=754d8bc4"
import script from "./UserTypeSelectorContainer.vue?vue&type=script&lang=js"
export * from "./UserTypeSelectorContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports